import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { Ticket_Interface } from 'src/app/Interface/Ticket_Interface';
import { Ticket_Ref_Interface } from 'src/app/Interface/Ticket_Ref_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TicketService {

constructor(private http:HttpClient) { }

  GetRecord(readed:number):Observable<Array<Ticket_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Ticket?readed="+readed).pipe(
      map(data=>{
        return data as Array<Ticket_Interface>
      })
    )
  }

  GetDetail(id:number):Observable<any>{
    return this.http.get(environment.BaseUrl + "Daro/Ticket/GetDetail?id="+id).pipe(
      map(data=>{
        return data as any
      })
    )
  }



  SubmitTicket(message: string ,cutomerId:number , title:string, category_id:number ,file:Array<string>):Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var model = {
      id:0,
      title:title,
      customer_id:cutomerId,
      category_id:category_id
    }

    var body={
      model:model,
      message:message,
      files:file
    }


      return this.http.post(environment.BaseUrl + "Daro/Ticket/SubmitTicket",body,{headers}).pipe(
        map(data=>{
          return data as any
        })
      )

  }

  SubmitTicketAdmin(message: string ,customer:Array<Customer_List_Interface>, title:string  , category_id:number ,file:Array<string>):Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var local_customer:Array<number>=[]

    for(let item of customer)
    {
      local_customer.push(item.id)
    }

    var model = {
      id:0,
      title:title,

    }

    var body={
      model:model,
      message:message,
      customer:local_customer,
      files:file,
      category_id:category_id,
    }


      return this.http.post(environment.BaseUrl + "Daro/Ticket/SubmitTicketAdmin",body,{headers}).pipe(
        map(data=>{
          return data as any
        })
      )

  }

  ReplyTicket(message: string ,id:number ,file:Array<string>):Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var model = {
      id:id,

    }

    var body={
      model:model,
      message:message,
      files:file
    }


      return this.http.post(environment.BaseUrl + "Daro/Ticket/ReplyTicket",body,{headers}).pipe(
        map(data=>{
          return data as any
        })
      )

  }


  uploadFile(body){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Ticket/Upload", body).pipe(
      map(data=>{

        return data
      })
    )
  }

}
